import React, { useContext, useState, useRef } from "react";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

// #region Components
import Input from "shared/components/FormElements/Input";
import Button from "shared/components/FormElements/Button";
import CustomSelect from "shared/components/FormElements/Select";
import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";
import ErrorModal from "shared/components/UIElements/ErrorModal";
import DatePicker from "shared/components/FormElements/DatePicker";
// #endregion Components

// #region Utils
import { transfertypes } from "shared/util/types";
import { VALIDATOR_REQUIRE } from "shared/util/validators";
// #endregion Utils

// #region Hooks
import { useForm } from "shared/hooks/form-hook";
import { useHttpClient } from "shared/hooks/http-hook";
import { AuthContext } from "shared/context/auth-context";
import { StoreContext } from "shared/context/store-context";
import { CheckTimeString } from "shared/util/time";
// #endregion Hooks

import "./Item.css";

const TransferNew = (props) => {
  const auth = useContext(AuthContext);
  const store = useContext(StoreContext);
  const [list, setList] = useState([]);

  const [showAlert, setShowAlert] = useState(false);
  const alertMessageRef = useRef("");

  let personelOptions;

  if (store.studentOptions) {
    personelOptions = store.studentOptions.map((studentoption) => {
      return { value: studentoption.value, label: studentoption.label.split("-")[0].trim() };
    });
  }

  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const updateStoreItems = store.UpdateTransfers;
  const ItemTypeTR = "Transfer";
  const APIEndPoint = "transfers";

  const itemSubmitHandler = async (event) => {
    event.preventDefault();

    if (
      !CheckTimeString(formState.inputs.transfertime.value) ||
      !CheckTimeString(formState.inputs.transfertime.value)
    ) {
      alertMessageRef.current = "Saat bilgisini **:** formatında giriniz. Örnek: 07:00 ya da 18:35";
      setShowAlert(true);
      return;
    }

    try {
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/${APIEndPoint}`,
        "POST",
        JSON.stringify({
          name: formState.inputs.name.value,
          type: formState.inputs.type.value,
          school: formState.inputs.school.value,
          transferdate: formState.inputs.transferdate.value,
          transfertime: formState.inputs.transfertime.value,
          done: formState.inputs.done.value,
          vehicleRoutes: [],
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );

      updateStoreItems();
    } catch (err) {}
  };

  const [formState, inputHandler] = useForm(
    {
      school: { value: "", isValid: false },
      name: { value: "", isValid: false },
      type: { value: "", isValid: false },
      transferdate: { value: "", isValid: false },
      transfertime: { value: "", isValid: false },
      done: { value: false, isValid: true },
      vehicleRoutes: { value: [], isValid: true },
    },
    false
  );

  if (isLoading || !store.studentOptions) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShowAlert(false);
  };

  // eslint-disable-next-line
  const AddStudent = async (event) => {
    if (formState.inputs.personel.value && formState.inputs.personelLocation) {
      const studentId = formState.inputs.personel.value;
      const studentName = personelOptions.find((student) => student.value === studentId).label;

      if (list.find((student) => student.studentId === studentId)) {
        alert("Bu yolcu listeye daha önce eklenmiş durumda.");
        return;
      }

      const personelLocationId = formState.inputs.personelLocation.value;
      const personelLocation = store.pLocationsOptions.find((item) => item.value === personelLocationId).label;

      setList([
        ...list,
        { studentId: studentId, plocationId: personelLocationId, studentName: studentName, address: personelLocation },
      ]);
    }
  };
  // eslint-disable-next-line
  const RemoveStudent = (id) => {
    const updatedList = list.filter((item) => item.studentId !== id);
    setList(updatedList);
  };

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />

      <Snackbar
        open={showAlert}
        autoHideDuration={2000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MuiAlert onClose={handleAlertClose} severity="error" sx={{ width: "100%" }}>
          {alertMessageRef.current}
        </MuiAlert>
      </Snackbar>

      <div>
        <form className="new-item-form" onSubmit={itemSubmitHandler}>
          {(isLoading || !store.studentOptions) && <LoadingSpinner asOverlay />}
          {/* <h3>{ItemTypeTR} Ekle</h3> */}
          <CustomSelect
            options={store.schoolOptions}
            id="school"
            onInput={inputHandler}
            label="Kurum"
            validators={[VALIDATOR_REQUIRE()]}
          ></CustomSelect>

          <Input
            id="name"
            element="input"
            type="text"
            label="Transfer İsmi"
            validators={[VALIDATOR_REQUIRE()]}
            errorText="Transfer ismi giriniz."
            onInput={inputHandler}
          />
          <CustomSelect options={transfertypes} id="type" onInput={inputHandler} label="Transfer Tipi"></CustomSelect>

          <DatePicker
            id="transferdate"
            onInput={inputHandler}
            label="Transfer Tarihi"
            validators={[VALIDATOR_REQUIRE()]}
          ></DatePicker>

          <Input
            id="transfertime"
            element="input"
            type="text"
            label="Havalimanında olma saati"
            validators={[VALIDATOR_REQUIRE()]}
            errorText="**:** formatında giriniz. Örnek: 07:00 ya da 18:35"
            onInput={inputHandler}
          />

          {/* <div className="pRoutePersonelContainer">
            <CustomSelect
              options={personelOptions}
              id="personel"
              isMulti={false}
              onInput={inputHandler}
              label="Personel"
            ></CustomSelect>

            <CustomSelect
              options={store.pLocationsOptions}
              id="personelLocation"
              isMulti={false}
              onInput={inputHandler}
              label="Alınacağı Yer"
            ></CustomSelect>
            <Button type="button" danger onClick={AddStudent}>
              Personel Ekle
            </Button>
          </div> */}
          <br />
          <Button type="submit" disabled={!formState.isValid}>
            Yeni {ItemTypeTR} Yarat
          </Button>
        </form>

        {/* <div className="new-item-form">
          <TableContainer component={Paper} sx={{ minWidth: 650 }}>
            <Table
              sx={{ minWidth: 650, width: "100%", justifyContent: "center", margin: "auto" }}
              stickyHeader
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>
                    <b>Personel</b>
                  </TableCell>
                  <TableCell align="right">
                    <b>Adres</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((row) => (
                  <TableRow key={row.key} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                    <TableCell width="30px" component="th" scope="row">
                      <Button type="button" danger onClick={() => RemoveStudent(row.studentId)}>
                        Sil
                      </Button>
                    </TableCell>

                    <TableCell component="th" scope="row">
                      {row.studentName}
                    </TableCell>
                    <TableCell scope="row" align="right">
                      {row.address}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div> */}
      </div>
    </React.Fragment>
  );
};

export default TransferNew;
